(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/e-instant-react/assets/javascripts/shared/hooks/use-meta-tags.js') >= 0) return;  svs.modules.push('/modules/e-instant-react/assets/javascripts/shared/hooks/use-meta-tags.js');
"use strict";


const {
  useLocation,
  matchPath
} = ReactRouterDOM;
const {
  useEffect,
  useCallback
} = React;
setGlobal('svs.eInstant.shared.hooks.useMetaTags', function () {
  let ticketInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  const {
    pathname
  } = useLocation();
  const updateSeoTags = useCallback(function () {
    let manualPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let seoTitle = svs.eInstant.data.defaultModuleTitle;
    let seoDescription = '';
    let seoKeywords = '';
    if (ticketInfo) {
      seoTitle = (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.seoTitle) || (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.name);
      seoDescription = (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.seoDescription) || (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.name);
      seoKeywords = (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.seoKeywords) || (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.name);
    }
    for (const route of Object.keys(svs.core.data.routesMetaData)) {
      if (matchPath(manualPath || pathname, {
        path: route,
        exact: true
      })) {
        var _routeMatch$title, _routeMatch$metaDescr, _routeMatch$metaKeywo;
        const routeMatch = svs.core.data.routesMetaData[route];
        const newTitle = (routeMatch === null || routeMatch === void 0 || (_routeMatch$title = routeMatch.title) === null || _routeMatch$title === void 0 ? void 0 : _routeMatch$title.replace(/{{seoTitle}}/g, seoTitle)) || seoTitle;
        document.title = newTitle;
        svs.eInstant.logger.debug("Setting page title to: ".concat(newTitle));
        const newSeoDescription = (routeMatch === null || routeMatch === void 0 || (_routeMatch$metaDescr = routeMatch.metaDescription) === null || _routeMatch$metaDescr === void 0 ? void 0 : _routeMatch$metaDescr.replace(/{{productMetaDescription}}/g, seoDescription)) || seoDescription;
        const newSeoKeywords = (routeMatch === null || routeMatch === void 0 || (_routeMatch$metaKeywo = routeMatch.metaKeywords) === null || _routeMatch$metaKeywo === void 0 ? void 0 : _routeMatch$metaKeywo.replace(/{{productMetaKeywords}}/g, seoKeywords)) || seoKeywords;
        svs.eInstant.util.setMetaTags(newTitle, newSeoDescription, newSeoKeywords);
        return;
      }
    }
    document.title = svs.eInstant.data.defaultModuleTitle;
    const {
      title = svs.eInstant.data.defaultModuleTitle,
      metaDescription = '',
      metaKeywords = ''
    } = svs.eInstant.data.defaultSeo;
    svs.eInstant.util.setMetaTags(title, metaDescription, metaKeywords);
  }, [pathname, ticketInfo]);
  useEffect(() => {
    updateSeoTags();
  }, []);
  return {
    update: updateSeoTags
  };
});

 })(window);